export class ChangedTabEvent extends Event {
    tabIndex: 0|1|2;

    constructor(newTab: 0 | 1 | 2) {
        super("changedTab");

        this.tabIndex = newTab;
    }

}

declare global {
    interface WindowEventMap {
        tabUpdate: ChangedTabEvent;
    }
}